// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Banner_wrapper__DNP32","title":"Banner_title__1rf1v","buttonWrapper":"Banner_buttonWrapper__3oY7Q","readMore":"Banner_readMore__2fBi1"};